import { ArchivedFilter } from "@avenueops/shared-types";
import { useProcessTableState } from "context/ProcessTableContext";
import React from "react";
import { humanizeDuration } from "utils/time";
import { trpc } from "utils/trpc";

interface Props {
  archived: ArchivedFilter;
  isDashboard: boolean;
}

export default function SignalAnalyticsSection({ archived, isDashboard }: Props) {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [{ filters, groupBy, search, sort, timeFrame, timeFrameStartIncl, timeFrameEndExcl }] = useProcessTableState();
  const { data: processListAggregates } = trpc.processes.getProcessListAggregates.useQuery({
    filters: filters ?? [],
    groupBy,
    search,
    sort: sort ?? [],
    timeFrame,
    timeFrameStartIncl: timeFrameStartIncl ? timeFrameStartIncl.toString() : undefined,
    timeFrameEndExcl: timeFrameEndExcl ? timeFrameEndExcl.toString() : undefined,
    timeZone,
    archived,
    isDashboard,
  });
  const { meanTimeToAcknowledge, meanTimeToResolve, meanTimeToFirstResolve } = processListAggregates ?? {};

  return processListAggregates ? (
    <div className="bg-gray-100 text-sm px-5 py-4 text-gray-500 flex flex-col gap-1">
      <span>
        <a className="font-bold">Mean Time to Acknowledgement: </a>
        <a>{meanTimeToAcknowledge != null ? humanizeDuration(meanTimeToAcknowledge) : "N/A"}</a>
      </span>
      {meanTimeToResolve !== meanTimeToFirstResolve ? (
        <span>
          <a className="font-bold">Mean Time to First Resolution: </a>
          <a>{meanTimeToFirstResolve != null ? humanizeDuration(meanTimeToFirstResolve) : "N/A"}</a>
        </span>
      ) : null}
      <span>
        <a className="font-bold">{`Mean Time to ${meanTimeToResolve !== meanTimeToFirstResolve ? "Final" : ""} Resolution: `}</a>
        <a>{meanTimeToResolve != null ? humanizeDuration(meanTimeToResolve) : "N/A"}</a>
      </span>
    </div>
  ) : null;
}
